import React from 'react';
import { Card, Space } from 'antd';
import classNames from 'classnames';
import { fetchFileDownload } from '../../api/services';
import '../../assets/iconfont.css';
import './StandardCard.css';
import { formatDate, formatSize } from '../../utils/utils';

const StandardCard = ({
  file,
  mark,
  updateIndex,
  updateIsShow,
  currentIndex,
  isShow,
  title,
}) => {
  const { name, size, release_date, doc_id, external_url = '' } = file;
  const cardClass =
    currentIndex === mark && isShow
      ? {
          title: classNames('file-title', 'file-title-active'),
          clicked: 'card-selected',
          icon_font: 'icon-active',
          icon: 'icon-active',
        }
      : {
          title: 'file-title',
          clicked: '',
          icon_font: '',
          icon: '',
        };
  return (
    <div
      onClick={() => {
        updateIndex(mark);
        if (title !== '固件') return;
        if (currentIndex === mark) {
          updateIsShow(!isShow);
        } else {
          updateIsShow(true);
        }
      }}
    >
      <Card className={cardClass.clicked}>
        <div className='card-content'>
          <div className='card-content-left'>
            <div
              className={cardClass.title}
              title={name}
            >
              {name}
            </div>
            {external_url ? null : (
              <Space>
                <i className={`iconfont icon-TimeCircle ${cardClass.icon}`}>
                  <span className={cardClass.icon_font}>
                    {formatDate(release_date)}
                  </span>
                </i>
                <i className={`iconfont icon-folderopen ${cardClass.icon}`}>
                  <span className={cardClass.icon_font}>
                    {formatSize(size)}
                  </span>
                </i>
              </Space>
            )}
          </div>
          <div className={`download ${cardClass.icon}`}>
            <i
              className='iconfont icon-download'
              onClick={async () => {
                if (external_url) {
                  window.open(external_url, '_blank');
                } else {
                  const res = await fetchFileDownload(doc_id);
                  if (res.status === 200) {
                    window.open(res.result.url, '_blank');
                  }
                }
              }}
            />
          </div>
        </div>
      </Card>
    </div>
  );
};

export default StandardCard;
